// removed by extract-text-webpack-plugin
module.exports = {"table":"_97323286ee_src-comparableSales-_TabSummary_table","root":"_16ee637ed2_src-comparableSales-_TabSummary_root","leftTable":"bfc54355a2_src-comparableSales-_TabSummary_leftTable","rightTable":"_6445faf3a7_src-comparableSales-_TabSummary_rightTable"};


//////////////////
// WEBPACK FOOTER
// ./src/comparableSales/TabSummary.css
// module id = 1635
// module chunks = 0